// Copyright (c) 2020 Deere & Company

import Criteria from '../state/criteria';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateCriteria = (state, action) =>
    Criteria.update(state, {
        [action.attribute]: {
            $set: action.value
        }
    });

const resetCriteria = () => getDefaultState().criteria;

export default (state = getDefaultState().criteria, action) => {

    const actionTypes = {
        [actions.UPDATE_PART_COVERAGE_SEARCH_CRITERIA]: updateCriteria,
        [actions.RESET_PART_COVERAGE_SEARCH_REPORT]: resetCriteria
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/parts-coverage-search/reducers/criteria.js